import React from "react";
import { Route, useLocation } from "wouter";
import { AccountSettings } from "@/pages/settings/AccountSettings.tsx";
import { LooksSettings } from "@/pages/settings/LooksSettings.tsx";
import { UpdatesSettings } from "@/pages/settings/UpdatesSettings.tsx";
import { ArrowLeftIcon } from "lucide-react";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select.tsx";

export const MobileSettingsPage: React.FC = (props) => {
	const [location, setLocation] = useLocation();
	const currentPage = location.split("/")[1];

	const handleChange = (value: string) => {
		setLocation(`/${value}`);
	};

	return (
		<div>
			<div className={"border-b p-4 flex gap-4 items-center"}>
				<a href={"/"}>
					<ArrowLeftIcon className={"w-6 h-6"} />
				</a>
				<Select onValueChange={handleChange} value={currentPage}>
					<SelectTrigger className="w-[180px]">
						<SelectValue placeholder="Theme" />
					</SelectTrigger>
					<SelectContent>
						<SelectItem value="account">
							Account Settings
						</SelectItem>
						<SelectItem value="looks">
							Appearance Settings
						</SelectItem>
						<SelectItem value="updates">
							App Updates
						</SelectItem>
					</SelectContent>
				</Select>
			</div>
			<Route path={"/account"} component={AccountSettings} />
			<Route path={"/looks"} component={LooksSettings} />
			<Route path={"/updates"} component={UpdatesSettings} />
		</div>
	);
};
